"use client";
import { WishlistContext } from "@/context/WishlistContext";
import { CornerDownRight, Heart } from "lucide-react";
import Link from "next/link";
import { useContext, useEffect, useState } from "react";

const AddWishlist = ({ product }) => {
  const { wishlist, toggleWishlist } = useContext(WishlistContext);
  const [wishlistProducts, setWishlistProducts] = useState([]);

  useEffect(() => {
    setWishlistProducts(wishlist);
  }, [wishlist]);

  const isInWishlist = wishlistProducts.some(
    (item) => item?._id === product?._id
  );

  return (
    <>
      {isInWishlist ? (
        <div
          variant="outline"
          className="flex items-center gap-1 cursor-pointer"
        >
          <CornerDownRight size={15} className="text-brand-sky" />
          <Link
            href="/wishlist"
            className="text-brand-sky font-medium text-sm hover:text-brand-deep transition-colors"
          >
            View wishlist
          </Link>
        </div>
      ) : (
        <div
          onClick={() => toggleWishlist(product)}
          className="group flex items-center gap-1 cursor-pointer text-muted-foreground transition-colors"
        >
          <Heart
            size={16}
            className="group-hover:text-brand-sky transition-colors"
          />
          <p className="group-hover:text-brand-sky transition-colors">
            Add to wishlist
          </p>
        </div>
      )}
    </>
  );
};

export default AddWishlist;